export default function Home() {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2rem',
  };

  const galleryStyle = {
    width: '100%',
    maxWidth: '800px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  };

  const imageStyle = {
    width: '100%',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  };

  return (
    <div style={containerStyle}>
      <h2>Stay tuned for updates!</h2>
      <h4 style={{marginBottom: '1.5rem' }}>For now enjoy these family photos!</h4>
      <div style={galleryStyle}>
        <img
          style={imageStyle}
          src="/pictures/raven_jake_1.jpg"
          alt="Raven and Jake"
        />
        <img
          style={imageStyle}
          src="/pictures/raven_janvi_1.jpg"
          alt="Janvi and Raven"
        />
        <img
          style={imageStyle}
          src="/pictures/raven_janvi_2.jpg"
          alt="Janvi and Raven"
        />
        <img
          style={imageStyle}
          src="/pictures/raven_sleeping.jpg"
          alt="Raven Sleeping"
        />
      </div>
    </div>
  );
}